import CoconeuseBioTemplate from "../../components/coconeuses/CoconeuseBioTemplate";

const CoconeuseValerieValouse = () => (
  <CoconeuseBioTemplate
    name="Valérie"
    subtitle="Yoga sensible & vibrant"
    mainPhoto="https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/as2yuj7o_WhatsApp%20Image%202026-02-01%20at%2018.53.40.jpeg"
    bioText={[
      "Je suis Valérie.",
      "Depuis plus de vingt ans, le yoga m'accompagne et m'enseigne à écouter, respecter et aimer le corps dans toutes ses dimensions.",
      "J'aime guider des pratiques douces, vivantes et profondes, où chacun·e peut se reconnecter à soi, libérer les tensions et retrouver de l'espace.",
      "Mon approche est intuitive, ancrée et évolutive — nourrie de ce que je vis et de ce que je sens.",
      "À Bali comme ailleurs, je vous propose un yoga sensible, adapté, et surtout… vibrant.",
    ]}
    bioPdf="https://customer-assets.emergentagent.com/job_d1425ff6-fbcb-4880-b341-80ef8fe0aeaa/artifacts/d9dibw3t_Bio%20Vale%CC%81rie%202026%20.pdf"
    galleryPhotos={[
      "https://customer-assets.emergentagent.com/job_5c218319-678c-4c56-b4c3-2039fdc76918/artifacts/3l1qv8o3_DSC01618.jpg",
      "https://customer-assets.emergentagent.com/job_5c218319-678c-4c56-b4c3-2039fdc76918/artifacts/f3py7tw1_DSC00865.jpg",
      "https://customer-assets.emergentagent.com/job_5c218319-678c-4c56-b4c3-2039fdc76918/artifacts/hmddviq2_DSC02443.jpg",
    ]}
    expertise={["Yoga", "Pratiques somatiques", "Connexion au corps"]}
    backPath="/coconeuses#profil-valerie"
    backLabel="Retour aux Coconeuses"
  />
);

export default CoconeuseValerieValouse;
